import * as types from '@/store/mutation-types'
import i18n from '@/i18n'
import { sectionType } from '@/helpers/enums'
import store from '@/store'
export default {
    namespaced: true,
    state: {
        configurations: {
            staffConfig: {}, 
            customersConfig: {},
            materialsConfig: {}, 
            visitsConfig: {} 
        },
        allConfigurations: [],
        customersTypesConf: [],
        customerType: [],

        fieldsInStaff: [],
        fieldsRoleInStaff: [],

        fieldsCustomer: [],
        fieldsCustomersTypes: [],

        fieldsMaterials: [],
        fieldsVisits: [],
        roleEmployee: {}
    },
    actions: {
        fetchEnum ({ commit }) {
            return window.axios.get('/configuration/systemSectionsAndValues').then(({ data }) => {
                const staff = data.items.find(c => c.name === 'Staff').children.filter(d => d.isMain === true)
                const roleInStaff = data.items.find(c => c.name === 'Staff').children.filter(d => d.isMain === false)

                const customers = data.items.find(c => c.name === 'Customer').children.filter(d => d.isMain === true)
                const customersTypes = data.items.find(c => c.name === 'Customer').children.filter(d => d.isMain === false)

                const materialsFields = data.items.find(c => c.name === 'Materials').children

                const visitsFields = data.items.find(c => c.name === 'Visits').children

                commit(types.STORE_FIELDS_IN_STAFF, staff)
                commit(types.STORE_ROLE_IN_STAFF, roleInStaff)

                commit(types.STORE_FIELDS_IN_CUSTOMERS, customers)
                commit(types.STORE_TYPES_OF_CUSTOMERS, customersTypes)

                commit(types.STORE_FIELDS_IN_MATERIALS, materialsFields)
                commit(types.STORE_FIELDS_IN_VISITS, visitsFields)
            })
        },
        fetchAll ({ commit }) {
            const items = [
                // staff
                {
                    section: 1,
                    key: null,
                    data: store.state.configuration.fieldsInStaff,
                    configId: null
                },
                // customers
                {
                    section: 2,
                    key: null,
                    data: store.state.configuration.fieldsCustomer,
                    configId: null
                },
                // visits  
                {  
                    section: 4,
                    key: null,
                    data: store.state.configuration.fieldsVisits,
                    configId: null
                },  
                // materials
                {
                    section: 3,
                    key: null,
                    data: store.state.configuration.fieldsMaterials,
                    configId: null
                }
            ]
            for (let k = 0; k < store.state.entityType.customersTypes.length; k++) {
                items.push({
                    section: 2,
                    key: store.state.entityType.customersTypes[k]?.id,
                    data: JSON.parse(JSON.stringify(store.state.configuration.fieldsCustomersTypes)),
                    configId: null
                })
            }

            for (let j = 0; j < store.state.rolePermission.roles.length; j++) {
                items.push({
                    section: 1,
                    key: store.state.rolePermission.roles[j]?.id,
                    data: JSON.parse(JSON.stringify(store.state.configuration.fieldsRoleInStaff)),
                    configId: null
                })
            }
            return window.axios.get('/Configuration', { once: true }).then(({ data }) => {
                console.log(items.length)
                for (let i = 0; i < items.length; i++) {
                    const getSection = data.find(c => c.section === items[i].section && c.key === items[i].key)

                    if (
                        getSection && 
                        (
                            data.find(c => c.section === items[i].section && c.key === items[i].key).id !== null && 
                            data.find(c => c.section === items[i].section && c.key === items[i].key).id !== undefined
                        )
                    ) {
                        items[i].configId = data.find(c => c.section === items[i].section && c.key === items[i].key)?.id
                    
                        const itemPer = !(items[i].section === 'Customer' && items[i].key === null) ? items[i].data : store.state.entityType.customersTypes

                        const valuesArray = items[i] ? data.find(c => c.section === items[i].section && c.key === items[i].key).values.split(',').map(Number) : []
                        
                        for (let j = 0; j < itemPer?.length; j++) {
                            if (valuesArray.find(c => c === itemPer[j].value)) {
                                itemPer[j].booleanValue = true
                                itemPer[j].key = items[i].key
                                itemPer[j].configId = data.find(c => c.section === items[i].section && c.key === items[i].key).id
                            } else {
                                itemPer[j].booleanValue = false
                                itemPer[j].key = items[i].key
                                itemPer[j].configId = data.find(c => c.section === items[i].section && c.key === items[i].key).id
                            }
                        }
                    } else {
                        for (let k = 0; k < items[i].data.length; k++) {
                            items[i].data[k] = {
                                name: items[i].data[k].name,
                                value: items[i].data[k].value,
                                isMain: items[i].data[k].isMain,
                                key: items[i].key,
                                booleanValue: false
                            }
                        }
                    }
                }
                
                const staffConfig = items.find(c => c.section === sectionType.staff)?.data.reduce((acc, item) => {
                    acc[item.name] = item.booleanValue;
                    return acc;
                }, {});

                // customers
                const customersConfig = items.find(c => c.section === sectionType.customers)?.data?.reduce((acc, item) => {
                    acc[item.name] = item.booleanValue;
                    return acc;
                }, {});

                // materials
                const materialsConfig = items.find(c => c.section === sectionType.materials)?.data.reduce((acc, item) => {
                    acc[item.name] = item.booleanValue;
                    return acc;
                }, {})

                // visits
                const visitsConfig = items.find(c => c.section === sectionType.visits)?.data.reduce((acc, item) => {
                    acc[item.name] = item.booleanValue;
                    return acc;
                }, {})
                // customer type 
                const customerType = items.filter(c => c.section === sectionType.customers && c.key !== null).map(c => ({
                    ...c,
                    data: c?.data.reduce((acc, item) => {
                        acc[item.name] = item.booleanValue;
                        return acc }, {}),
                    key: c.key
                }))

                // employee role
                const roleEmployee = items.filter(c => c.section === sectionType.staff && c.key !== null).map(c => ({
                    ...c,
                    data: c?.data.reduce((acc, item) => {
                        acc[item.name] = item.booleanValue;
                        return acc }, {}),
                    key: c.key
                }))

                const configurations = { staffConfig, customersConfig, materialsConfig, visitsConfig }
                commit(types.STORE_CONFIGURATION, configurations)
                commit(types.STORE_CON_TYPES, customerType)
                commit(types.STORE_ROLE_EMPLOYEE, roleEmployee)
                commit(types.STORE_ALL_CONFIGURATION, items)
                console.log('items', items)
                return items
            })
        },

        fetchByFilter ({ commit }, { propertyIds, sectionId, key }) {
            var urlSearchParams = new URLSearchParams();
            var params = { key }
            if (propertyIds) propertyIds.forEach(propertyId => { urlSearchParams.append('propertyIds', propertyId) })
            if (sectionId) sectionId.forEach(propertsectionIdyId => { urlSearchParams.append('sectionId', sectionId) })
            Object.keys(params).forEach(param => {
                if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
            });
            return window.axios.get('/configuration/ByFilters', { params: urlSearchParams }).then((data) => {
                return data
            })
        },

        fetchById ({ commit }, { propertyId }) {
            return window.axios.get(`/configuration/${propertyId}`).then(({ data }) => {
                return data
            })
        },

        create ({ commit }, { section, key, values }) {
            return window.axios.post('/configuration', { 
                section,
                key,
                values
            }).then(({ data }) => {
                return data
            })
        },

        update({ commit }, { section, key, values, id }) {
            return window.axios.put('/configuration', { 
                section,
                key,
                values,
            },
            {
                params: {
                    id
                }
            }
        ).then(({ data }) => {
                return data
            })
        },

        updateCustomerTypes ({ commit }, data) {
            commit(types.STORE_CUSTOMERS_TYPES_CONFIG, data.data)
        },

        reset ({ commit }) {
            commit(types.RESET)
        }
    },
    mutations: {
        [types.STORE_CONFIGURATION](state, configurations) {
            state.configurations = configurations
        },

        [types.STORE_CUSTOMERS_TYPES_CONFIG] (state, customersTypesConf) {
            state.customersTypesConf = customersTypesConf
        },

        [types.STORE_CON_TYPES] (state, customerType) {
            state.customerType = customerType
        },
        // enums
        [types.STORE_FIELDS_IN_STAFF] (state, fieldsInStaff) {
            state.fieldsInStaff = fieldsInStaff
        },

        [types.STORE_ROLE_IN_STAFF] (state, fieldsRoleInStaff) {
            state.fieldsRoleInStaff = fieldsRoleInStaff
        },

        [types.STORE_FIELDS_IN_CUSTOMERS] (state, fieldsCustomer) {
            state.fieldsCustomer = fieldsCustomer
        },
        
        [types.STORE_TYPES_OF_CUSTOMERS] (state, fieldsCustomersTypes) {
            state.fieldsCustomersTypes = fieldsCustomersTypes
        },
        [types.STORE_FIELDS_IN_MATERIALS] (state, fieldsMaterials) {
            state.fieldsMaterials = fieldsMaterials
        },
        [types.STORE_FIELDS_IN_VISITS] (state, fieldsVisits) {
            state.fieldsVisits = fieldsVisits
        },

        [types.STORE_ALL_CONFIGURATION] (state, allConfigurations) {
            state.allConfigurations = allConfigurations
        },

        [types.STORE_ROLE_EMPLOYEE] (state, roleEmployee) {
            state.roleEmployee = roleEmployee
        },

        [types.RESET] (state) {
            state.configurations = {}
            state.customersTypesConf = []
            state.customerType = []
            state.fieldsInStaff = []
            state.fieldsRoleInStaff = []
            state.fieldsCustomer = []
            state.fieldsCustomersTypes = []
            state.fieldsMaterials = []
            state.fieldsVisits = []
            state.allConfigurations = []
            state.roleEmployee = {}
        }
    },
    getters: {}
}